// extracted by mini-css-extract-plugin
export default {"markdown":"GenerateInstructions_markdown__jEhUw","dark":"GenerateInstructions_dark__Bbia1"};